// extracted by mini-css-extract-plugin
module.exports = {"SourcePage":"SourcePage_SourcePage__IuNLK","Title":"SourcePage_Title__qYYwJ","LinkWrapper":"SourcePage_LinkWrapper__pWFDW","LinkNote":"SourcePage_LinkNote__PDYc0"};